import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import { useTheme, makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles(theme => ({
  catalogBorder: {
    borderTop: props =>
      theme.border(
        8,
        "solid",
        theme.palette.catalogColors[props.color].overlay
      ),
    [theme.breakpoints.up("md")]: {
      // For some reason only calling the method here makes it actually hide. Otherwise it still shows? I'm a bit confused
      borderTop: () => "none",
      borderLeft: props =>
        theme.border(
          5,
          "solid",
          theme.palette.catalogColors[props.color].overlay
        )
    }
  },
  drawerContainer: {
    padding: [[theme.spacing(1), theme.spacing(2)]],
    [theme.breakpoints.up("md")]: {
      padding: 0,
      margin: [[theme.spacing(1), theme.spacing(2)]],
      width: "55vw"
    }
  }
}));

/**
 * Global instance of our inspector drawer.
 * This way we can keep all drawer instances the same or modify with a prop
 */
const OSSInspectorDrawer = ({
  open,
  onClose,
  children,
  color = "blue",
  spacing = 4
}) => {
  const classes = useStyles({ color });
  const theme = useTheme();

  // On small screens we anchor the drawer to the bottom of the screen.
  const drawerAnchor = useMediaQuery(theme.breakpoints.down("sm"))
    ? "bottom"
    : "right";

  return (
    <Drawer
      anchor={drawerAnchor}
      onClose={onClose}
      open={open}
      PaperProps={{
        className: classes.catalogBorder
      }}
    >
      <Grid
        className={classes.drawerContainer}
        container
        justify="flex-start"
        spacing={spacing}
      >
        {children}
      </Grid>
    </Drawer>
  );
};

export default OSSInspectorDrawer;
